import { render, staticRenderFns } from "./globalCharts.vue?vue&type=template&id=35d85628"
import script from "./globalCharts.vue?vue&type=script&lang=js"
export * from "./globalCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d85628')) {
      api.createRecord('35d85628', component.options)
    } else {
      api.reload('35d85628', component.options)
    }
    module.hot.accept("./globalCharts.vue?vue&type=template&id=35d85628", function () {
      api.rerender('35d85628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/charts/globalCharts.vue"
export default component.exports